module.exports = __webpack_public_path__ + "static/media/06.63d6ef31.jpg";